(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libero-footer"]) return;
  try {
    
(() => {
  if (window.liberoFooterController) {
    window.liberoFooterController.refresh();
    return;
  }
  const openers = new WeakMap();
  const triggerSelector = '[data-libero-request], [data-libero-disclosure]';
  const getTarget = link => document.getElementById(link.getAttribute('aria-controls'));
  const getLinks = footer => [...document.querySelectorAll(triggerSelector)].filter(link => getTarget(link)?.closest('.libero-footer') === footer);
  const sync = footer => {
    getLinks(footer).forEach(link => {
      const target = getTarget(link);
      link.setAttribute('aria-expanded', target?.open ? 'true' : 'false');
    });
  };
  const refresh = () => document.querySelectorAll('.libero-footer').forEach(sync);
  window.liberoFooterController = { refresh };
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('toggle', event => {
    if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches('.libero-footer__disclosure')) return;
    const footer = event.target.closest('.libero-footer');
    if (footer) sync(footer);
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest(triggerSelector);
    if (!link) return;
    const target = getTarget(link);
    const footer = target?.closest('.libero-footer');
    if (!footer) return;
    event.preventDefault();
    footer.querySelectorAll('.libero-footer__disclosure[open]').forEach(panel => {
      if (panel !== target) panel.open = false;
    });
    openers.set(target, link);
    link.closest('.libero-header')?.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    if (link.dataset.liberoRequest) {
      const field = target.querySelector('[name="contact[Request type]"]');
      if (field) field.value = link.dataset.liberoRequest;
    }
    target.open = true;
    sync(footer);
    target.scrollIntoView({ block:'start' });
    target.querySelector('summary')?.focus();
  });
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest(triggerSelector);
    if (event.key === ' ' && trigger && getTarget(trigger)?.closest('.libero-footer')) {
      event.preventDefault();
      trigger.click();
      return;
    }
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('.libero-footer__disclosure[open]');
    if (!panel) return;
    event.preventDefault();
    panel.open = false;
    const footer = panel.closest('.libero-footer');
    if (footer) sync(footer);
    const opener = openers.get(panel);
    let focusTarget = opener;
    for (let parent = opener?.parentElement; parent; parent = parent.parentElement) {
      if (parent instanceof HTMLDetailsElement && !parent.open) focusTarget = parent.querySelector('summary');
    }
    focusTarget?.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libero-portfolio-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('libero-art-wall')) {
  customElements.define('libero-art-wall', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.querySelectorAll('[data-art-open]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const card = link.closest('[data-title]');
          const template = card.querySelector('template');
          if (!template) return;
          event.preventDefault();
          this.opener = link;
          this.previousOverflow = document.body.style.overflow;
          this.savedScrollY = window.scrollY;
          const body = this.dialog.querySelector('[data-art-body]');
          body.replaceChildren(template.content.cloneNode(true));
          this.dialog.querySelector('[data-art-title]').textContent = card.dataset.title;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.track = body.querySelector('.libero-art-wall__track');
          this.previous = body.querySelector('[data-art-prev]');
          this.next = body.querySelector('[data-art-next]');
          this.counter = body.querySelector('[data-art-counter]');
          this.total = this.track.children.length;
          this.index = 0;
          this.previous.addEventListener('click', () => this.goTo(this.index - 1));
          this.next.addEventListener('click', () => this.goTo(this.index + 1));
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
              this.updateControls();
            });
          }, { passive: true });
          this.track.scrollLeft = 0;
          this.dialog.scrollTop = 0;
          this.updateControls();
        });
      });
      this.dialog.querySelector('[data-art-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.dialog.addEventListener('close', () => {
        cancelAnimationFrame(this.frame);
        document.body.style.overflow = this.previousOverflow || '';
        window.scrollTo({ top: this.savedScrollY, behavior: 'instant' });
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.dialog.querySelector('[data-art-body]').replaceChildren();
      });
    }
    goTo(index) {
      const nextIndex = Math.max(0, Math.min(index, this.total - 1));
      this.track.scrollTo({ left: nextIndex * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateControls() {
      this.index = Math.max(0, Math.min(this.index, this.total - 1));
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.total - 1;
      this.counter.textContent = (this.index + 1) + ' / ' + this.total;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libero-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!document.documentElement.dataset.liberoDetailLinksBound) {
    document.documentElement.dataset.liberoDetailLinksBound = 'true';
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#LiberoDetail"]');
      if (!link) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (target?.tagName === 'DETAILS') target.open = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["libero-review-recovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.liberoReviewRecovery) {
      window.liberoReviewRecovery.init();
      return;
    }
    let frame = null;
    const observers = [];
    const disconnect = () => {
      observers.splice(0).forEach(observer => observer.disconnect());
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
    };
    const sync = () => {
      frame = null;
      const hasCards = Array.from(document.querySelectorAll('.jdgm-cards-carousel')).some(native => {
        const scoped = Boolean(document.querySelector('[data-libero-scoped-observer]'));
        const cards = native.querySelector(scoped ? '.jdgm-card' : '.jdgm-cards-wrapper');
        return Boolean(scoped ? cards : cards?.textContent.trim()) && cards.getClientRects().length > 0 && native.getClientRects().length > 0
          && getComputedStyle(native).visibility !== 'hidden' && !native.classList.contains('jdgm-hidden');
      });
      document.querySelectorAll('[data-libero-review-recovery]').forEach(section => {
        if (section.hidden !== hasCards) section.hidden = hasCards;
      });
    };
    const schedule = () => {
      if (frame === null) frame = requestAnimationFrame(sync);
    };
    const init = () => {
      disconnect();
      if (document.querySelector('[data-libero-review-primary]')) {
        document.querySelectorAll('[data-libero-review-primary]').forEach(section => { section.hidden = false; });
        return;
      }
      sync();
      if (!document.querySelector('[data-libero-review-recovery]') || !('MutationObserver' in window)) return;
      document.querySelectorAll('.jdgm-cards-carousel').forEach(native => {
        const observer = new MutationObserver(schedule);
        if (!document.querySelector('[data-libero-scoped-observer]')) {
          observer.observe(native.closest('.shopify-section') || native, {
            childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
          });
        } else {
          observer.observe(native, { childList: true, subtree: true });
          const visibilityObserver = new MutationObserver(schedule);
          visibilityObserver.observe(native, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          const parent = native.closest('.shopify-section');
          if (parent && parent !== native) visibilityObserver.observe(parent, {
            attributes: true, attributeFilter: ['class', 'style', 'hidden']
          });
          observers.push(visibilityObserver);
        }
        observers.push(observer);
      });
    };
    window.liberoReviewRecovery = { init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => {
      disconnect();
      frame = requestAnimationFrame(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
